// Safely get initial state from localStorage
const getInitialState = (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      const parsedData = JSON.parse(data);
      return (Array.isArray(parsedData) && parsedData.length > 0) ? parsedData[0] : 0;
    }
    return 0;
  } catch (error) {
    console.warn(`Failed to parse ${key} from localStorage:`, error);
    return 0;
  }
};

let initialState = getInitialState("actmoredata");

const actmoredata = (state = initialState, action) => {

    switch(action.type){ 
      case "ACTMORE" : {
        const next = action.parm;
        // Keep cached form-customization payload unless caller sets plrforminfo explicitly
        if (
          next &&
          next !== 0 &&
          typeof next === "object" &&
          !Object.prototype.hasOwnProperty.call(next, "plrforminfo") &&
          state &&
          state !== 0 &&
          state.plrforminfo
        ) {
          return { ...next, plrforminfo: state.plrforminfo };
        }
        return next;
      }
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default actmoredata